import axios from "axios";

export const handleCepDetailResult = async (cep: string, setState: Function) => {

    const cepNumberWithoutHash = cep.split("-").join("");
    const {data} = await axios.get(
        `https://viacep.com.br/ws/${cepNumberWithoutHash}/json/`
    );

    setState(data);
} 